/*
 USAGE:
 analytics_helper.add(EVENT_TYPE, DATA);
 */

var ANALYTICS_EVENT_TYPES = {
    FBAR: 1,
    INSPECTOR: 2,
    TICKER_SEARCH: 3,
    PG_CHANGE: 4,
    COLUMN_EXPAND: {
        SINGLE: 5,
        ALL: 6
    },
    ROW_EXPAND: {
        SINGLE: 7,
        ALL: 8
    },
    HELP_PAGE: 9,
    ADD_FAVORITE: 10,
    SAVE_VIEW: 11,
    PANELS: {
        SOURCE: {DIMENSION: 12, SELECT: 13, REMOVE: 14},
        PERIOD: {MULTI_PERIOD: 15, FISCAL_TYPE: 16, START: 17, END: 18},
        TICKER: {DIMENSION: 19, SELECT: 20, REMOVE: 21},
        ADJUST: {CHANGE: 22},
        BASIS: {CHANGE: 23},
        SCENARIO: {DIMENSION: 24, SELECT: 25, REMOVE: 26},
        REVISION: {DIMENSION: 27, SELECT: 28, REMOVE: 29},
        GROWTH_TYPE: {CHANGE:30}
    },
    DISCLAIMER_PAGE: 27
};

analytics_helper = (function () {
    var event_queue = [];
    var curr_timer = undefined;
    var POST_URL = '/portal/analyticslog/'
    var POST_INTERVAL = 300 * 1000;
    var BATCH_SIZE = 5;
    var send_alone = 5;

    send = function () {
        //This should post all the events to server and clean the queue.
        if (event_queue.length > 0) {
            post_data = {'data': JSON.stringify(event_queue)};
            event_queue = [];
            var csrftoken = getCookie('csrftoken');
            $.ajax({
                type: "POST",
                async: true,
                url: POST_URL,
                data: post_data,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                dataType: "json",
                headers: {"X-CSRFToken": csrftoken},
                success: function () {
                },
                error: function (msg) {
                    console.error(msg);
                }
            });
        }
        //Start a timer for next post
        if (typeof curr_timer != 'undefined') {
            clearTimeout(curr_timer);
            curr_timer = undefined;
        }
        curr_timer = setTimeout(send, POST_INTERVAL);
    };

    var Analytics = function () {
    };
    Analytics.FBAR = 1;
    Analytics.prototype.add = function (event_type, data) {
        evt = {};
        evt.type = event_type;
        evt.data = data;
        evt.ts = (new Date()).getTime();
        event_queue.push(evt);
        if (event_queue.length >= BATCH_SIZE || send_alone > 0) {
            if (typeof curr_timer != 'undefined') {
                clearTimeout(curr_timer);
                curr_timer = undefined;
            }
            curr_timer = setTimeout(send, 0);
            if (send_alone > 0)
                send_alone--;
        }
    };

    return new Analytics();
})();

function sourcePanelChanged(){
    "use strict";
    var sourcePanel = MEData.panels.filter(function(value){return value.name=="Sources"})[0];
    var oldSourcePanel = gridLoadedMEData.panels.filter(function(value){return value.name=="Sources"})[0];
    return JSON.stringify(sourcePanel) != JSON.stringify(oldSourcePanel);

}

function getSourceData(){
    'use strict';
    var sourcePanelValues = MEData.panels.filter(function(value){return value.name=="Sources"})[0].values;
    var analytics_object = [];
    for(var i=0; i< sourcePanelValues.length; i++) {
        var nobj = {};
        var currentObject = sourcePanelValues[i];
        nobj.name = currentObject.name;
        nobj.selected = currentObject.selected;
        nobj.values = [];
        if(!currentObject.hasOwnProperty("values")){
            currentObject.values = [];
        }
        // currentValues = currentObject.values || [];
        for(var j=0; j< currentObject.values.length; j++) {
            var currentValueObject = currentObject.values[j];
            var n2obj = {};
            n2obj.selected = currentValueObject.selected;
            n2obj.focus = currentValueObject.focus;
            n2obj.name = currentValueObject.name;
            nobj.values.push(n2obj);
        }
        analytics_object.push(nobj);
    }
    return analytics_object;
}


function analyticsProcessor(event, feature_string, msg) {
    var ticker_name = company;
    'use strict';
    if (window.analyticsLogLevel != "ALL") {
        return;
    }
    if (!event && !feature_string) {
        return;
    }
    //console.log(event, typeof(event));
    var target_element = event;
    if (event && event.target) {
        target_element = event.target;
    }
    var feature = "";
    var checkSliderValues = false;
    var checkSelectedRevision = false;
    var checkSourceSelectionChange = false;
    var checkSettingsDialogValues = false;
    if (target_element && target_element.id) {
        var elid = target_element.id;
    }
    var feature_name = '';
    if (event != null){
        if($(event.target).attr('feature') != undefined){
           feature_name = $(event.target).attr('feature');
        }
        else if($(event).attr('feature') != undefined){
            feature_name = $(event).attr('feature');
        }
    }
    var extras = {};
    /*var accountingBasisIDs = ["account-Operating", "account-All", "account-GAAP"];
    var legendIDs = ["mmlegendP", "mmlegendPP"];*/
    if (feature_string) {
        if (feature_string == "row") {
            feature = "OPTIONS_SOURCES_ROW";
            extras.sourcedata = getSourceData();
        } else if (feature_string == "column") {
            feature = "OPTIONS_SOURCES_COLUMN";
            extras.sourcedata = getSourceData();
        } else {
            feature = feature_string;
        }
    } else if (elid == "toggle-commonsize") {
        feature = "COMMONSIZE_PERCENTAGE";
    } else if (elid == "toggle-normal") {
        feature = "COMMONSIZE_NORMAL";
    } else if (elid == "options-refresh-buttons-apply") {
        feature = "OPTIONS_REFRESH_BUTTONS_APPLY";
        checkSliderValues = true;
        checkSourceSelectionChange = true;
    } else if (elid == "options-refresh-buttons-cancel") {
        feature = "OPTIONS_REFRESH_BUTTONS_CANCEL";
    }else if(feature_name =='analysispanel'){
        feature = 'OPTIONS_ANALYSIS';
        extras.dimension = rightPanelSettings().jsonData;
        var analysistabid = ['revisiondev', 'variation', 'high-low', 'surprise'];
        if (analysistabid.indexOf(target_element.id) >= 0) {
            extras.analysistab = target_element.id.toUpperCase();
            if (analysistabid.indexOf(target_element.id) == 2){
                checkSliderValues  = false;
            } else {
                checkSliderValues = true;
            }
        }
        if (target_element.name && target_element.name.indexOf('high-low') > -1){
            if (target_element.value != undefined) {
                extras.value = target_element.value;
            }
            if (target_element.checked != undefined) {
                extras.selection = String(target_element.checked);
            }
        } else {
            if (target_element.value != undefined) {
                extras.revisionvalue = target_element.value;
                checkSliderValues = true;
            }
            if (target_element.checked != undefined) {
                extras.selection = String(target_element.checked);
            }
        }
    }
    else if(feature_name == "sourcespanel"){
        feature = "OPTIONS_SOURCES";
    }
    else if(feature_name == "analytics(labs)panel"){
        feature = "OPTIONS_ANALYTICS";
    }
    else if(feature_name == "visualizations(labs)panel"){
        feature = "OPTIONS_VISUALIZATIONS";
    }
    /*else if (elid == "variation") {
        // check if this block can be removed
        checkSliderValues = true;
        feature = "OPTIONS_ANALYSIS_VARIATION";
    } else if (elid == "revisiondev") {
        // check if this block can be removed
        checkSliderValues = true;
        feature = "OPTIONS_ANALYSIS_REVISION";
    }*/
    else if(feature_name == 'periodspanel'){
        feature = "OPTIONS_PERIODS";
        //if(target_element.id == 'periodend' || target_element.id == 'periodstart'){
        //   extras.selectedperiod = target_element.id + " " + target_element.value;
        //}
        //else {
        //    extras.selectedperiod = target_element.value;
        //}
    }
    /*else if (elid == "rdsingle") {
        // check if this block can be removed
        feature = "OPTIONS_PERIOD_SINGLE";
        extras.periods = getSelectedPeriodFromPanels(true);
    } else if (elid == "rdmulti") {
        // check if this block can be removed
        feature = "OPTIONS_PERIOD_MULTI";
        extras.periods = getSelectedPeriodFromPanels(true);
    }*/
    else if(feature_name == 'revisionspanel'){
        feature = 'OPTIONS_REVISION';
        //if(target_element.value){
        //  extras.revision = target_element.value
        //}
        //if(target_element.checked != undefined){
        //   extras.selection = String(target_element.checked)
        //}
        //var revisiontab = ['row', 'column', 'off'];
        //if(revisiontab.indexOf($(target_element).attr('value')) >= 0){
        // extras.revisiontabselected = $(target_element).attr('value').toUpperCase()
        //}
    }
    /*else if (elid == "offrevision") {
        // check if this block can be removed
        feature = "OPTIONS_REVISION_OFF";
    } else if (elid == "rowrevision") {
        // check if this block can be removed
        feature = "OPTIONS_REVISION_ROW";
        checkSelectedRevision = true;
    } else if (elid == "colrevision") {
        // check if this block can be removed
        feature = "OPTIONS_REVISION_COLUMN";
        checkSelectedRevision = true;
    }*/
    else if(feature_name == 'missingdatapanel'){
        feature = "OPTIONS_MISSING_DATA";
        extras.missingdata = elid;
        if (target_element.checked != undefined){
         extras.selection = String(target_element.checked);
        }
    }
    /*else if ($("#missingdata").has(elid).length && elid.is("input")) {
        // check if this block can be removed
        feature = "OPTIONS_MISSING_DATA";
        extras.missingdataid = elid;
        extras.missingdatavalue = elid.val()
    }*/
    else if(feature_name == "accountingbasispanel"){
        feature = "OPTIONS_ACCOUNTING_BASIS";
        extras.accountingbasis = elid;
        if(target_element.checked != undefined) {
            extras.selection = String(target_element.checked);
        }
    }
    /*else if (accountingBasisIDs.indexOf(elid) >= 0) {
        // check if this block can be removed
        feature = "OPTIONS_ACCOUNTING_BASIS";
        extras.accountbasisid = elid;
        extras.accountbasisidstate = target_element.value
    }*/
    else if(feature_name == 'legendpanel'){
        feature = "OPTIONS_LEGEND";
    }
    /*else if (legendIDs.indexOf(elid) >= 0) {
        feature = "OPTIONS_LEGEND";
    }*/
    else if(feature_name == 'displaysettingspanel'){
        feature = "OPTIONS_DISPLAY_SETTINGS";
        if(target_element.value != undefined){
           extras.display = target_element.value
        }
        if(target_element.checked != undefined){
            extras.selection = String(target_element.checked);
        }
    }
    else if (elid == "chkboxShow full line name") {
        feature = "OPTIONS_DISPLAYSETTINGS_SHOWFULLLINENAME";
        // extras.checked = elid.
    } else if (elid == "Saveview") {
        feature = "SAVE_SETTINGS_AS_CUSTOM_VIEW";
        extras.favorites = $("#addFavourites:checked").length ? true : false;
    } else if (elid == "addFavourites") {
        feature = "SAVE_SETTINGS_AS_CUSTOM_VIEW_ADD_FAVORITES";
        checkSettingsDialogValues = true;
    } else if (elid == "dialogName" && $("#settingDialog #dialog-name")) {
        feature = "SAVE_SETTINGS_AS_CUSTOM_VIEW_DIALOG_NAME";
        checkSettingsDialogValues = true;
    } else if (elid == "saveDialog" && $("#settingDialog #saveDialog")) {
        feature = "SAVE_SETTINGS_AS_CUSTOM_VIEW_SAVE_BUTTON";
        checkSettingsDialogValues = true;
    } else if (elid == "cancelDialog" && $("#settingDialog #cancelDialog")) {
        feature = "SAVE_SETITNGS_AS_CUSTOM_VIEW_CANCEL_BUTTON";
        checkSettingsDialogValues = true;
    }
    if (!feature) {
        return;
    }
    if (checkSelectedRevision) {
        extras.revision = $("#revision input[name='chknamerev']:checked").map(function () {
            return this.value;
        }).get();
    }
    if (checkSettingsDialogValues) {
        extras.add_favourites_checked = $("#addFavourites:checked").length ? true : false;
        extras.text = $("#settingDialog #dialog-name").val()
    }
    var cut = "";
    var source = "";
    extras.path = window.location.href;
    if (checkSliderValues) {
        if ($("#variation").hasClass("analysis_sections_selected")) {
            extras.variationSliderValue = parseInt($("#variationSlider").slider('value'));
        }
        if ($("#revisiondev").hasClass("analysis_sections_selected")) {
            extras.revisionSliderValue = parseInt($("#revisionSlider").slider('value'));
        }
    }
    if (checkSourceSelectionChange) {
        if (sourcePanelChanged()) {
            extras.sourcedata = getSourceData();
        }
    }
    if (typeof(MEData) != "undefined") {
        cut = MEData.view_code;
        extras.tab = window.pg;
        if (MEData.hasOwnProperty("source")) {
            source = MEData.source;
        }
    }
    if (msg) {
        extras.message = msg
    }
    if (feature) {
        if ((event && event.nodeName) || feature == "USER_INACTIVE") {
            dummyAjaxRequest(ticker_name, cut, feature, extras, source);
        } else {
            callDummyAjaxRequest(event, ticker_name, cut, feature, extras, source);
        }
        //console.log("logged", feature, extras);
    }
}
